import { Injectable } from "@nestjs/common";
import { InjectDataSource } from "@nestjs/typeorm";
import { CommonResponseModel, GantSizeColumns } from "@project-management-system/shared-models";
import { DataSource } from "typeorm";
import { GenericTransactionManager } from "../../../typeorm-transactions";
import { SizeEntity } from "./size-entity";
import { SizeRepository } from "./size-repo";

@Injectable()
export class SizeService {
    constructor(
        @InjectDataSource()
        private dataSource: DataSource,
        private repo: SizeRepository
    ) { }

    async saveSizeInfo(formData: any): Promise<CommonResponseModel> {
        const transactionManager = new GenericTransactionManager(this.dataSource);
        try {
            await transactionManager.startTransaction();
            const columnArray = [];
            const updatedArray = formData.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').replace(/#/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });
            const difference = columnArray.filter((element) => !GantSizeColumns.includes(element));
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponseModel(false, 1110, "Excel columns don't match. Please attach the correct file.");
            }
            const filteredArray = updatedArray.filter((obj) => {
                return Object.values(obj).every((value) => value !== null && value !== '' && value !== '-' && value !== ' ');
            });
            const convertedData = filteredArray.map((obj) => {
                const result = {};
                for (const key in obj) {
                    result[key] = obj[key] === "" ? null : obj[key];
                }
                return result;
            });
            const repository = transactionManager.getRepository(SizeEntity);
            for (const data of convertedData) {
                if (!data) continue;
                const size = data.Size != null ? String(data.Size).trim() : null;
                const movexSize = data.MovexSize != null ? String(data.MovexSize).toUpperCase().trim() : null;
                const existingRecord = await repository.findOne({where: {size,movexSize}});
                if (existingRecord) {
                    continue;
                }
                const newRecord = { size, movexSize };
                try {
                    const savedRecord = await repository.save(newRecord);
                    if (!savedRecord) {
                        console.error("Failed to save record:", data);
                        await transactionManager.releaseTransaction();
                        return new CommonResponseModel(false, 0, "Failed to save some records");
                    }
                } catch (error) {
                    console.error("Error saving record:", error);
                    await transactionManager.releaseTransaction();
                    return new CommonResponseModel(false, 0, "Failed to save some records due to an error");
                }
            }
            
            await transactionManager.completeTransaction();
            return new CommonResponseModel(true, 1, 'Data saved successfully');
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new CommonResponseModel(false, 0, 'Something went wrong');
        }
    }

    async getSizeInfo(): Promise<CommonResponseModel> {
        try {
            const info = await this.repo.find()
            if (info) {
                return new CommonResponseModel(true, 1, 'Data retrieved', info)
            } else {
                return new CommonResponseModel(false, 0, 'No data found')
            }
        } catch (err) {
            return new CommonResponseModel(false, 0, 'Something went wrong', err)
        }
    }

}